//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addBuycar from '../buycar/add.vue'
export default {
    components: {
        addBuycar
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            dataList: [],
            lastPage: false
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(vm && vm.$refs.goodsScrollerRef){
                vm.$vux.loading.show();
                setTimeout(function () {
                    vm.$refs.goodsScrollerRef.scrollTo(0, vm.$store.state.scrollerPosition.goodsList, true);
                }, 100);
                setTimeout(() => {
                    vm.$vux.loading.hide()
                }, 500);
            }
        })
    },
    beforeRouteLeave (to, from, next) {
        var scrollerPosition = this.$refs.goodsScrollerRef.getPosition();
        this.$store.state.scrollerPosition.goodsList = scrollerPosition.top;
        next();
    },
    watch: {
        dataList: {
            handler() {
                sessionStorage.goodsList = JSON.stringify(this.dataList);
            },
            deep: true
        }
    },
    methods: {
        /**
         * type: 1赋值，2push
         */
        loadList(type, done) {
            let that = this;
            let searchItem = {
                currentPage: that.currentPage,
                pageSize: that.pageSize
            }
            that.$axios.get('/api/v1.0/familyApp/goods', {
                params: searchItem
            }).then(function (response) {
                if(response.status == 200) {
                    var storeGoodsList = response.body.storeGoodsList.map((item) => {
                        item.poster = item.photo;
                        item.goodsName = item.goodsTitle;
                        return item;
                    });
                    if(type == 1) {
                        that.dataList = storeGoodsList;
                    } else {
                        response.body.storeGoodsList.forEach((item) => {
                            that.dataList.push(item);
                        });
                    }
                    that.dealHeight();
                    setTimeout(() => {
                       that.dealHeight(); 
                    }, 500);
                    done&&done(true);
                } else if(response.status == 203) {
                    that.lastPage = true;
                    that.$refs.goodsScrollerRef.finishInfinite(true);
                }
            })
        },
        doNext(done) {
            if(!this.lastPage) {
                this.currentPage++;
                this.loadList(2, done);
            } else {
                done&&done(true);
            }
        },
        doRefresh(done) {
            this.currentPage = 1;
            this.loadList(1);
            this.lastPage = false;
            setTimeout(() => {
                done&&done(true);
            }, 1000);
        },
        dealHeight() {
            this.$nextTick(() => {
                var nodes = $(".gd-content");
                for(var i=0; i<nodes.length; i++) {
                    var node = nodes[i];
                    var height = $(node).height();
                    var height1 = $($(node).find(".gd-name")[0]).height();
                    var height2 = $($(node).find(".gd-price")[0]).height();
                    // console.log("总高："+height + "，合高：" + (height1 + height2 + 11))
                    if(height > (height1 + height2 + 11)) {
                        $($(node).find(".gd-price")[0]).addClass("gd-price-absolute");
                    }
                }
            })
        },
        toDetail(item) {
            this.$router.push("/goodsDetail?backPath="+this.$route.path+"&goodsId="+item.goodsId);
        },
        readyBuy(item) {
            this.$refs.addBuycarRef.openPopup(item);
        }
    },
    created() {
        if(sessionStorage.goodsList) {
            this.dataList = JSON.parse(sessionStorage.goodsList);
        }
        this.doRefresh();
    },
}



// WEBPACK FOOTER //
// ./src/components/goods/list.vue